/**
 * Models a chart
 */

import Brace from "backbone.brace";
import UserCollection from "../../collections/chart-reviews/reviewers/selectable";
import Notes from "../../collections/notes";
import environment from "../../common/environment";

const Model = Brace.Model.extend({
  urlRoot: environment.getEndpoint("chart-reviews"),
  namedAttributes: {
    id: Number,
    auditId: Number,
    scannerId: Number,
    member: Number,
    provider: Number,
    projectId: Number,
    reviewers: [Number],
    providerGroupId: Number,
    providerGroupName: String,
    providerGroupNumber: String,
    retrievalStatus: String,
    retrievalStatusNAReason: String,
    chartAttributes: [Number],
    statusValue: String,
    customerRefNumber: String,
    customerLocation: String,
    userField1: String,
    userField2: String,
    userField3: String,
    reviewNumber: String,
    notes: Notes,
    requestedDate: Date,
    receivedDate: String,
    reviewedDate: String,
    openedDate: Date,
    openedBy: Number,
    lastModifiedDate: Date,
    lastModifiedBy: Number,
    closedDate: String,
    closedBy: Number,
    naReasonCode: String,
    users: UserCollection,
    chaseListRank: Number,
    diagnosisAttributes: [Number],
  },
  defaults: {
    id: null,
    auditId: null,
    scannerId: null,
    member: null,
    provider: null,
    projectId: null,
    reviewers: [],
    providerGroupId: null,
    providerGroupName: null,
    providerGroupNumber: null,
    retrievalStatus: null,
    retrievalStatusNAReason: null,
    chartAttributes: [],
    statusValue: null,
    customerRefNumber: null,
    customerLocation: null,
    userField1: null,
    userField2: null,
    userField3: null,
    reviewNumber: null,
    notes: new Notes(),
    requestedDate: null,
    receivedDate: null,
    reviewedDate: null,
    openedDate: null,
    openedBy: null,
    lastModifiedDate: null,
    lastModifiedBy: null,
    closedDate: null,
    closedBy: null,
    naReasonCode: null,
    users: new UserCollection(),
    chaseListRank: null,
    diagnosisAttributes: [],
  },
  validate(attrs) {
    // nullify received date when left empty (and placeholder text is submitted)
    if ("month/day/year" === attrs.receivedDate) {
      this.setReceivedDate(null);
    }

    // a member is required
    if (!_.isNumber(attrs.member)) {
      return "You must select a member for this chart.";
    }

    // a provider is required
    if (!_.isNumber(attrs.provider)) {
      return "You must select a provider for this chart.";
    }

    // a projectId is required
    if (!_.isNumber(attrs.projectId)) {
      return "You must select a project for this chart.";
    }

    // retrievalStatus is required
    if (_.isEmpty(attrs.retrievalStatus)) {
      return "You must select the retrieval status for this chart.";
    } else {
      // reset reason when not NA
      if (attrs.retrievalStatus !== "NOT_AVAILABLE") {
        this.setRetrievalStatusNAReason(null);
      } else {
        if (_.isEmpty(attrs.retrievalStatusNAReason)) {
          return "You must select a reason for your choice of retrieval status.";
        }
      }
    }
  },
});

export { Model as default };
